import styled, { keyframes } from 'styled-components'
import { colors, fontScope, radius, visuallyHidden } from '../tokens'

export const Row = styled.div`
  ${fontScope}
  display: flex;
  gap: 24px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const SkeletonCard = styled.div<{ $height: string }>`
  flex: 1 0 0;
  min-width: 0;
  box-sizing: border-box;
  height: ${({ $height }) => $height};
  padding: 21px 17px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.card};
  background: ${colors.white};
`

export const SkeletonGroup = styled.div`
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid ${colors.tableBorder};
  border-radius: ${radius.table};
  background: ${colors.white};
`

export const Stack = styled.div`
  ${fontScope}
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Message = styled.div`
  ${fontScope}
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  padding: 32px 24px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.card};
  background: ${colors.white};
  text-align: center;
`

export const MessageText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: ${colors.ink600};
`

export const RetryButton = styled.button`
  padding: 9.8px 16.8px;
  border: 0.8px solid ${colors.primary};
  border-radius: 6px;
  background: ${colors.primary};
  color: ${colors.white};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`

export const Notice = styled.div`
  ${fontScope}
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid ${colors.courtesyBg};
  border-radius: ${radius.card};
  background: ${colors.kpiIconBg};
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
  color: ${colors.ink800};
`

export const NoticeAction = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${colors.primaryStrong};
  font-size: 13px;
  font-weight: 700;
  line-height: 19.5px;
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    color: ${colors.ink400};
    cursor: not-allowed;
  }
`

const flip = keyframes`
  from { transform: rotateY(0deg); }
  to { transform: rotateY(360deg); }
`

export const LoadBox = styled.div`
  ${fontScope}
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 64px 12px;
`

export const SpinLogo = styled.img`
  && {
    width: 56px;
    height: 56px;
    max-width: none;
  }
  animation: ${flip} 1.6s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const LoadMsg = styled.p`
  margin: 0;
  min-height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.ink500};
`

export const HiddenText = styled.span`
  ${visuallyHidden}
`
